export const homeProbablyDisabled =
  "Hubo un error al realizar la operación. Es posible que el Home se encuentre en modo 'Solo Consulta', espere unos minutos y vuelva a intentarlo. Disculpe las molestias ocasionadas.";
